import styled from 'styled-components/macro';
import * as colors from '../../../common/colorConstants';
import { NextButton } from '../../../common/buttonsComponents';

export const Button = styled(NextButton)`
  float: none;
  margin-top: 30px;
  margin-left: 30px;
`;

export const TransferringContainer = styled.div`
  font-size: 11px;
  font-family: 'Roboto', sans-serif;
`;

export const InputRow = styled.div`
  position: relative;
  margin-top: 30px;
  margin-left: 30px;
`;

export const InputLabel = styled.label`
  color: ${colors.black4};
  font-weight: 400;
`;

export const Input = styled.input`
  max-width: 250px;
  width: 100%;
  display: block;
  padding: 4px 10px;
  margin-right: 12px;
  outline: none;
  background: ${colors.white};
  border-radius: 4px;
  border: 1px solid ${colors.lightGray21};
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11px;
  color: ${colors.darkGray1};
`;

export const CheckIcon = styled.img`
  position: absolute;
  left: 230px;
  bottom: 8px;
`;
